import ColourPalette from '@/support/ColourPalette'

export default class LeaveTypeColour extends ColourPalette {
  static colours = {
    ...ColourPalette.colours,
    Grey: '#8D9196',
  }

  static getSelectableColors = () => {
    return Object.entries(this.colours)
      .filter(colour => colour[0] !== 'Grey')
      .map(color => {
        return color[1]
      })
  }
}
